

import { fetchToken } from "../../../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_APPLIED_CANDIDATES } from "../../../../../common/URLs";

// export const fetchCandidateList = async (page) => {
//   const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_APPLIED_CANDIDATES}?page=${page}`; // Proxy path
//   try {
//     const token = await fetchToken()
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });
//   // console.log("response", response)
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.log("error", error);
//   }
// };

export const fetchCandidateList = async (page, status) => {
  const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_APPLIED_CANDIDATES}?page=${page}&status=${status}`; // Added status as query param

  try {
    const token = await fetchToken();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching candidates:", error);
    throw error; // Rethrow error so it can be caught in Redux thunk
  }
};



export const updateJobStatus = async (uuid, newStatus) => {
  const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_APPLIED_CANDIDATES}/${newStatus}/${uuid}`; 
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newStatus),
    });
    const data = await response.json(); 
    // console.log("API Data", data);
    return data;
  } catch (error) {
    throw error;
  }
};
